export const routes = {
  import: "/import",
  importlist: "/importlist",
  importfilter: "/importfilter",
  virtualinventory: "/virtualinventory",
  billingaddress:"/billingaddress",
  paymentaddress:"/paymentaddress",
  editorder:"/editorder/:id",
  shippingpreference:"/shippingpreference",
mycompany: "/mycompany",
  checkout: "/checkout",
  thumbnail: "/thumbnail",
  confirmation: "/confirmation",
  landingPage: "/",
};
